export default __webpack_public_path__ + "static/comment-53d3e9f68be1d84bc7c2856b54e120eb.jpg";